// media-library-image/media-library-image-editing.js

import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

export default class MediaLibraryVideoEditing extends Plugin {

    init() {

        // This plugin doesn't need anything special as it's just piggybacking off the existing imageBlock

    }

    _defineSchema() {

    }

    _defineConverters() {

    }

}
